import PropTypes from "prop-types";
import React from "react";

import * as classes from "./shadow.module.scss";

export default function Shadow({ children, isRaised }) {
  const classNames = [classes.shadow];

  if (isRaised) {
    classNames.push(classes.isRaised);
  }

  return <div className={classNames.join(" ")}>{children}</div>;
}

Shadow.defaultProps = {
  children: null,
  isRaised: false,
};

Shadow.propTypes = {
  children: PropTypes.node,
  isRaised: PropTypes.bool,
};
